<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="honeyTypeForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="honeyType" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                honeyTypeForm: () => import('../forms/HoneyTypeForm'),
                honeyType: () => import('../editViews/HoneyType'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                ],
                itemsField: 'honeyTypes',
                editPageName: 'honeyType',
                apiMethod: 'HoneyTypes',
                claimName: 'HoneyTypes',
                formTitle: 'Honey Type',
                excelTitle: 'Honey Types',
                hasEditPage: true,
            }
        },
    };
</script>
